"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M19.506 12.043a7.613 7.613 0 00-1.66-4.775 7.705 7.705 0 00-3.814-2.587V2c2.17.532 4.368 1.948 5.766 3.71a10.23 10.23 0 012.203 6.333c0 1.47-.322 2.92-.926 4.245l-1.922-1.927a7.71 7.71 0 00.353-2.318zm-2.652 0v.012l-2.822-2.83V7.442a5.16 5.16 0 012.822 4.603zM11.7 6.889V3.113L9.815 4.996l1.887 1.893zm-7.936-4.47l17.637 17.688-1.762 1.77-1.712-1.717A11.184 11.184 0 0114.032 22v-2.593a7.669 7.669 0 002.128-1.018l-4.46-4.473v7.06L6.189 15.47H3.804c-.99 0-1.792-.805-1.792-1.797v-3.26c0-.992.802-1.796 1.792-1.796h2.384l.115-.115L2 4.188 3.764 2.42z" }), "Mute");
//# sourceMappingURL=VolumeMute.js.map